// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 720px) {\n  .navbar-component__logo___2g5G3 {\n    width: 250px;\n  }\n}\n@media screen and (min-width: 721px) {\n  .navbar-component__logo___2g5G3 {\n    width: 350px;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"logo": "navbar-component__logo___2g5G3"
};
module.exports = exports;
